import { React, useState } from "react";
import Person3Icon from '@mui/icons-material/Person3';
import ForumIcon from '@mui/icons-material/Forum';
import BannerBreadcrumb from "../Components/BannerBreadcrumb";
const AbroadEducationLaonOverview = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Course"
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Blog"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    return (
        <>
            <BannerBreadcrumb head={"Education Loan for Abroad Studies"} parades={"All you need to know about education loans for studying abroad"} pagename={"Abroad Eduaction Loan Overview"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <h5 className="about-head">What are education loans?</h5>
                            <p className="loan-elegibility-des">An education loan is a financial aid that students apply for to fund their studies abroad. Different banks and financial institutions offer these loans at competitive interest rates, making quality education more affordable for students.<br /><br />Studying at renowned universities, especially abroad, opens doors to numerous opportunities. However, the cost of such education can be substantial. To bridge the financial gap, education loans for studying abroad become invaluable, enabling students from all backgrounds to pursue their dreams at top-tier institutions across the globe.<br /><br />With various banks and lenders providing student loan for abroad, choosing the right option can be overwhelming. This is where Credere comes in as a guiding light. We help students find the best education loan for their study abroad needs, tailored to their unique profiles, ensuring a seamless and hassle-free loan approval process.</p>
                            <h5 className="about-head">Types of Education Loans for Abroad Studies</h5>
                            <p className="loan-elegibility-des">Education loans are of two types, one that is taken with collateral i.e. a secured loan and one taken without collateral i.e. an unsecured loan. You need to understand the difference between the two before choosing the one that is right for you.</p>
                            <h5 className="about-head">Secured education loan</h5>
                            <ol className="subhead-ul">
                                <li>Requires the borrower to offer any collateral like immovable property, FD, Insurance Policy etc. against which the loan is offered.</li>
                                <li>Lower rate of interest.</li>
                                <li>The chances of approval are high.</li>
                                <li>Longer repayment period.</li>
                                <li>A higher loan amount can be availed.</li>
                                <li>No repayment during the study period.</li>
                                <li>Parental income is not required for approval.</li>
                            </ol>
                            <h5 className="about-head">Unsecured education loan</h5>
                            <ol className="subhead-ul">
                                <li>The borrower does not need to offer any collateral to get this loan.</li>
                                <li>Higher interest rate, usually 1.5% – 4% higher than the secured loan.</li>
                                <li>Is a more risky proposition for the bank, hence is not so easy to obtain a loan without collateral from the bank.</li>
                                <li>Comparatively shorter repayment period.</li>
                                <li>Some repayment during the study period.</li>
                                <li>Parental income is required for approval.</li>
                            </ol>

                            <h5 className="about-head">Types of Lenders Offering Education Loans for Abroad Studies</h5>
                            <p className="loan-elegibility-des">When considering student loans for studying abroad, you have three main categories of lenders to choose from: banks, Non-Banking Financial Companies (NBFCs), and international lenders. The lending choices within each category are as follows:</p>
                            <ol className="subhead-ul">
                                <li><b>Banks </b>: Traditional financial institutions that offer education loans to students pursuing studies abroad and are further divided into public and private banks.</li>
                                <li><b>NBFCs </b>: Non-Banking Financial Companies are financial institutions that offer various financial services similar to traditional banks but operate without a banking license.</li>
                                <li><b>International Lenders </b>: Financial entities based outside your home country that specialize in offering international education loan for international students.</li>
                            </ol>
                            <h5 className="about-head">Eligibility For Education Loan for Abroad</h5>
                            <ol className="subhead-ul">
                                <li><b>Nationality </b>: Must be an Indian citizen.</li>
                                <li><b>Admission </b>: Secured admission through merit or entrance tests.</li>
                                <li><b>Course Type </b>: Enrolled in career-oriented courses (UG/PG).</li>
                                <li><b>Academic Performance </b>: At least 50% marks in the last qualifying exam.</li>
                                <li><b>Collateral </b>: For secured loans, collateral might be required.</li>
                                <li><b>Co-applicant </b>: For unsecured loans, a co-applicant with a strong financial background may be necessary.</li>
                                <li><b>University and Course Reputation </b>: Factor in loan approval.</li>
                            </ol>

                            <h5 className="about-head">Documents Required for Education Loan for Abroad Studies</h5>
                            <p className="loan-elegibility-des">Education loan required documents vary from lender to lender and also depend on the type of education loan applied for. Here’re the general documents required by almost every lender:</p>
                            <h6 className="subhead">Identity-Related Documents (From Both Applicant & Co-applicant)</h6>

                            <h6 className="mt-4">KYC documents</h6>
                            <ol className="subhead-ul">
                                <li>PAN card</li>
                                <li>Driving license</li>
                                <li>Aadhar card</li>
                            </ol>
                            <h6 className="">Address proof</h6>
                            <ol className="subhead-ul">
                                <li>Aadhar card</li>
                                <li>Valid water/electricity/ LPG Bill</li>
                                <li>Voter’s ID card</li>
                                <li>Current house lease agreement</li>
                                <li>Valid passport</li>
                            </ol>
                            <h6 className="">Academic record documents (From Applicant)</h6>
                            <ol className="subhead-ul">
                                <li>10th result</li>
                                <li>12th result</li>
                                <li>Proof of admission</li>
                                <li>Under graduate result semester wise (If required)</li>
                                <li>Entrance exam result – abroad institutes (GRE, GMAT, TOEFL, IELTS etc.)</li>
                            </ol>
                            <h6 className="subhead">Financial Documents from the Co-applicant</h6>
                            <h6 className="mt-4">For salaried co-applicant</h6>
                            <ol className="subhead-ul">
                                <li>Salary slips of the last 3 months</li>
                                <li>Copy of Form 16 for last 2-3 years or copy of IT Returns for last 2-3 financial years, acknowledged by Income Tax Dept.</li>
                                <li>Bank account statement for the last 6 months (salary account).</li>
                            </ol>
                            <h6 className="">For Self-employed co-applicant</h6>
                            <ol className="subhead-ul">
                                <li>Business address proof (If Applicable)</li>
                                <li>TDS certificate (Form 16A, if applicable)</li>
                                <li>Last 3 years ITR</li>
                                <li>Certificate of qualification (for C.A./ Doctor and other professionals)</li>
                                <li>Bank account statement for the last 6 months</li>
                            </ol>
                            <h6 className="">Technical Documents for Collateral</h6>
                            <ol className="subhead-ul">
                                <li>Approved layout plan and permissions (if applicable)</li>
                                <li>NOC and allotment letter</li>
                                <li>Possession certificate (if applicable)</li>
                                <li>Copy of prior sale deeds</li>
                                <li>Conversion certificate where the property has changed from agricultural to non-agricultural use</li>
                                <li>Urban clearance certificate</li>
                            </ol>
                            <h6 className="">Legal Documents for Collateral</h6>
                            <ol className="subhead-ul">
                                <li>Sale/gift/partition deed</li>
                                <li>Khata certificate and extract</li>
                                <li>Encumbrance certificate (EC)</li>
                                <li>Latest property tax receipt</li>
                            </ol>
                            <h5 className="about-head">How Do I Apply for an Student Loan for Abroad?</h5>
                            <p className="loan-elegibility-des">Applying for student loans India studies abroad can be quite simple if done carefully. To help you answer the question, ‘How do I get an education loan for abroad studies?’ here are some steps that will assist you.</p>
                            <ol className="subhead-ul">
                                <li><b>Check eligibility with Us </b>: Credere Finance evaluates your profile and selects the best lender for you, making it easier to navigate the loan application process.</li>
                                <li><b>Discussion with education loan counselor </b>: Credere Finance’s education loan counselor will connect with you and help you understand all about foreign education loans and your chosen lender. The counselor will also provide you with a document checklist as well. </li>
                                <li><b>Document submission & verification </b>: Credere Finance streamlines the document submission process by offering doorstep pickup or a customized checklist for online uploads. Once submitted, they manage all remaining formalities and collaborate with the lender to verify your documents efficiently.</li>
                                <li><b>Loan approval & disbursement </b>: When all the documents are verified, you will get a loan approval letter and an agreement to sign. Once all this has been done you can take the loan disbursement as per your convenience.</li>
                            </ol>
                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input type="text" className="form-control finance-input" placeholder="E.g. Priya Senger" />
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input type="text" className="form-control finance-input" placeholder="E.g. priya@doe.com" />
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input type="tel" className="form-control finance-input" placeholder="E.g. 8888880000" />
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea type="text" className="form-control finance-input" placeholder="E.g. 8888880000" />
                                        </div>
                                        <div className="col-12">
                                            <button type="button" className="loan-btn w-100 mt-3">Submit</button>
                                        </div>


                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AbroadEducationLaonOverview;